/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

export const FIAT_DETAIL_DATA = {
    razorpay: {
        asset: {
            keyId: "rzp_test_CzuLdmG0xAMyRD", // Enter the Key ID generated
            amount: 5000,
            currencySymbol: '₹',
            currency: "INR",
            name: "Razorpay test.",
            description: "Test Transaction",
            order_id: "order_9A33XWu170gUtm",

            title: "Vlinder Razorpay experiment",
            address: "Vlinder test Office",
            color: "#61dafb",

            prefill: {
              name:  "Vlinder Dev",
              email: "Razorpay@example.com",
              contact: "9999999999"
            },

            retry: {
              enabled: false,
              max_count: 0,
            }
        }
    }
}
